import { FunctionComponent, Suspense, useMemo } from 'react'
import iconMap from '@/components/Iconography/icon-map'
import { useStyles } from './styles'
import { IllustrationProps } from './types'

import { RenderIf } from '../RenderIf'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'

export const Illustration: FunctionComponent<IllustrationProps> = ({
  name,
  color,
  width,
  height,
  size,
  hide,
  css,
  ...rest
}) => {
  const getWidth = useMemo(() => size || width || 'unset', [width, size])
  const getHeight = useMemo(() => size || height || 'unset', [height, size])
  const {
    theme: { controls },
  } = useThemeGeneratorContext()

  const hideIllustration = useMemo(() => {
    if (hide === undefined) return controls?.flagDesabilitarIlustracoes
    else return hide
  }, [hide, controls?.flagDesabilitarIlustracoes])

  const styles = useStyles({
    color,
    width: getWidth,
    height: getHeight,
  })

  const IllustrationFragment = iconMap?.illustrations?.[name] || 'span'

  return (
    <RenderIf condition={!hideIllustration}>
      <Suspense fallback={<span />}>
        <IllustrationFragment
          css={[styles.illustrationWrapper, css]}
          {...rest}
        />
      </Suspense>
    </RenderIf>
  )
}
